import { Typography } from '@mui/material';
// Utils and Helpers
import { SOLIDFI_CARD_SHIPPING_STATUS } from 'helpers/constants';
// Assets
import './DeliveryStatusTooltipTitle.css';

const DeliveryStatusTooltipTitle = ({ solidfiCard }) => {
    const { deliveryStatus, trackingNumber, trackingUrl } = solidfiCard.shipping;
    if (deliveryStatus === SOLIDFI_CARD_SHIPPING_STATUS.PENDING) {
        return (
            <>
                <Typography className="delivery-status-tooltip__physical-card-tracking">
                    Order Successful! We will send you a tracking id as soon as your card is shipped.
                </Typography>
                <Typography className="delivery-status-tooltip__physical-card-tracking">
                    Contact cardsupport@paystand.com with any questions
                </Typography>
            </>
        );
    }
    if (deliveryStatus === SOLIDFI_CARD_SHIPPING_STATUS.SHIPPED) {
        return (
            <>
                <Typography className="delivery-status-tooltip__physical-card-tracking">
                    Track your card using this UPS Tracking Number:{' '}
                    <a
                        className="delivery-status-tooltip__physical-card-tracking-number-link"
                        href={trackingUrl}
                        target="_blank"
                        rel="noreferrer">
                        #{trackingNumber}
                    </a>
                </Typography>
                <Typography className="delivery-status-tooltip__physical-card-tracking">
                    Contact cardsupport@paystand.com with any questions
                </Typography>
            </>
        );
    }
    if (deliveryStatus === SOLIDFI_CARD_SHIPPING_STATUS.DELIVERED) {
        return (
            <>
                <Typography className="delivery-status-tooltip__physical-card-tracking">Card Delivered!</Typography>
                <Typography className="delivery-status-tooltip__physical-card-tracking">
                    Next: Activate your card by clicking on the three dots on the right side and select Activate option
                </Typography>
            </>
        );
    }
    return (
        <>
            <Typography className="delivery-status-tooltip__physical-card-tracking">Card Delivered!</Typography>
            <Typography className="delivery-status-tooltip__physical-card-tracking">
                Next: Activate your card by clicking on the three dots on the right side and select Activate option
            </Typography>
        </>
    );
};

export default DeliveryStatusTooltipTitle;
